import React, { useState } from 'react'
import { useField } from 'formik'
import { DateRangePicker as DatePicker } from 'react-dates'
import { ICON_AFTER_POSITION } from 'react-dates/constants'
import 'moment/locale/pt-br'

import { Calendar, ChevronRight } from 'components/Icons'

import { Container, Label, PrevIcon, NextIcon, ErrorText } from './styles'

const DateRangePicker = ({ label, name, ...props }) => {
  const [focused, setFocused] = useState(false)
  const [{ value }, meta, { setValue }] = useField({ name, ...props })
  const hasError = meta.touched && meta.error

  const focusedInput = () => {
    if (focused) {
      if (!value.startDate) return 'startDate'
      if (!value.endDate) return 'endDate'
    }
  }

  return (
    <Container focused={focused} error={hasError} {...props}>
      <Label disabled={props.disabled} focused={focused} error={hasError}>
        {label}
      </Label>
      <DatePicker
        isValidDate={false}
        startDate={value.startDate || null}
        startDatePlaceholderText='Data inicial'
        displayFormat='DD/MM/YYYY'
        startDateId='start_date'
        endDate={value.endDate || null}
        endDatePlaceholderText='Data final'
        endDateId='end_date'
        onDatesChange={value => setValue(value)}
        focusedInput={focusedInput()}
        onFocusChange={focused => setFocused(focused)}
        customInputIcon={<Calendar />}
        customArrowIcon={<ChevronRight />}
        showDefaultInputIcon
        inputIconPosition={ICON_AFTER_POSITION}
        numberOfMonths={2}
        navPrev={<PrevIcon />}
        navNext={<NextIcon />}
        isOutsideRange={() => false}
        enableOutsideDays={true}
        showClearDates={value.startDate && value.endDate ? true : false}
      />
      {hasError && <ErrorText>{meta.error?.startDate ? meta.error?.startDate : meta.error?.endDate}</ErrorText>}
    </Container>
  )
}

export default DateRangePicker
